__webpack_require__.p = "https://webid.cdn.dhgamesdownload.com/assets/recompensas.pagostore.com/";